import { createSlice } from '@reduxjs/toolkit';

const initState = {
  collapsed: !(window.innerWidth > 1220),
  openDrawer: false,
};

const AppSlice = createSlice({
  name: 'app',
  initialState: initState,
  reducers: {
    toggleCollapsed(state) {
      state.collapsed = !state.collapsed;
    },
    toggleOpenDrawer(state) {
      state.openDrawer = !state.openDrawer;
    },
  },
});

export const { toggleCollapsed, toggleOpenDrawer } = AppSlice.actions;

export default AppSlice;
